// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"ee6a9269","167":"c42fdb43","453":"f6a897a4"}[chunkId] + ".chunk.js";
};